export const PROVINCE_TAX_TABLE = {
    AB: { code: 'AB', name: 'Alberta', gst: 0.05, pstQst: 0, pstQstLabel: '', hst: 0 },
    BC: { code: 'BC', name: 'British Columbia', gst: 0.05, pstQst: 0.07, pstQstLabel: 'PST 7%', hst: 0 },
    MB: { code: 'MB', name: 'Manitoba', gst: 0.05, pstQst: 0.07, pstQstLabel: 'RST 7%', hst: 0 },
    NB: { code: 'NB', name: 'New Brunswick', gst: 0, pstQst: 0, pstQstLabel: '', hst: 0.15 },
    NL: { code: 'NL', name: 'Newfoundland & Labrador', gst: 0, pstQst: 0, pstQstLabel: '', hst: 0.15 },
    NS: { code: 'NS', name: 'Nova Scotia', gst: 0, pstQst: 0, pstQstLabel: '', hst: 0.14 }, // reduced from 15% on April 1, 2025
    NT: { code: 'NT', name: 'Northwest Territories', gst: 0.05, pstQst: 0, pstQstLabel: '', hst: 0 },
    NU: { code: 'NU', name: 'Nunavut', gst: 0.05, pstQst: 0, pstQstLabel: '', hst: 0 },
    ON: { code: 'ON', name: 'Ontario', gst: 0, pstQst: 0, pstQstLabel: '', hst: 0.13 },
    PE: { code: 'PE', name: 'Prince Edward Island', gst: 0, pstQst: 0, pstQstLabel: '', hst: 0.15 },
    QC: { code: 'QC', name: 'Quebec', gst: 0.05, pstQst: 0.09975, pstQstLabel: 'QST 9.975%', hst: 0 },
    SK: { code: 'SK', name: 'Saskatchewan', gst: 0.05, pstQst: 0.06, pstQstLabel: 'PST 6%', hst: 0 },
    YT: { code: 'YT', name: 'Yukon', gst: 0.05, pstQst: 0, pstQstLabel: '', hst: 0 },
};
// Rounds to 2 decimal places using cents-based integer math to avoid float drift.
// Canonical definition for the shared package — imported by discount-engine.ts.
export function round2(n) {
    return Math.round(n * 100) / 100;
}
export function computeTaxes(amount, province, taxExempt) {
    // Tax-exempt, or no province to index (e.g. WORLD market): all zeros, never
    // touch PROVINCE_TAX_TABLE. CA callers always pass a valid province + the
    // taxExempt short-circuit is unchanged, so CA math is byte-identical.
    if (taxExempt || !province) {
        return { gst: 0, pstQst: 0, hst: 0, total: 0, pstQstLabel: '' };
    }
    const rule = PROVINCE_TAX_TABLE[province];
    if (!rule) {
        return { gst: 0, pstQst: 0, hst: 0, total: 0, pstQstLabel: '' };
    }
    const gst = round2(amount * rule.gst);
    const pstQst = round2(amount * rule.pstQst);
    const hst = round2(amount * rule.hst);
    return {
        gst,
        pstQst,
        hst,
        total: round2(gst + pstQst + hst),
        pstQstLabel: rule.pstQstLabel,
    };
}
